import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, normalizeStyle as _normalizeStyle, createTextVNode as _createTextVNode, createCommentVNode as _createCommentVNode, vModelSelect as _vModelSelect, withDirectives as _withDirectives, withModifiers as _withModifiers } from "vue"

const _hoisted_1 = { class: "card custom-shadow rounded-3 bg-white border mb-4" }
const _hoisted_2 = { class: "card-body p-4" }
const _hoisted_3 = { class: "d-flex justify-content-between align-items-center flex-wrap gap-1 mb-3" }
const _hoisted_4 = ["innerHTML"]
const _hoisted_5 = { class: "mb-0" }
const _hoisted_6 = ["innerHTML"]
const _hoisted_7 = {
  class: "nav nav-tabs bg-transparent border-bottom gap-2 gap-sm-5 pb-4",
  id: "yearDeadlinesTab",
  role: "tablist"
}
const _hoisted_8 = {
  class: "nav-item",
  role: "presentation"
}
const _hoisted_9 = ["innerHTML"]
const _hoisted_10 = {
  class: "nav-item",
  role: "presentation"
}
const _hoisted_11 = ["innerHTML"]
const _hoisted_12 = {
  class: "tab-content",
  id: "deadlinesTabContent"
}
const _hoisted_13 = {
  class: "tab-pane fade show active",
  id: "deadlines-table-pane",
  role: "tabpanel",
  "aria-labelledby": "deadlines-table-tab",
  tabindex: "0"
}
const _hoisted_14 = { class: "default-table-area style-two campaigns-table" }
const _hoisted_15 = { class: "table-responsive" }
const _hoisted_16 = { class: "table align-middle border-0" }
const _hoisted_17 = { class: "fs-14 fw-semibold mb-0" }
const _hoisted_18 = ["innerHTML"]
const _hoisted_19 = { class: "fs-12" }
const _hoisted_20 = { style: {"text-align":"right"} }
const _hoisted_21 = { class: "fs-14 fw-semibold" }
const _hoisted_22 = { key: 0 }
const _hoisted_23 = ["innerHTML"]
const _hoisted_24 = { class: "d-flex justify-content-between align-items-center mt-3" }
const _hoisted_25 = { class: "d-flex align-items-center" }
const _hoisted_26 = {
  key: 0,
  "aria-label": "Page navigation example"
}
const _hoisted_27 = { class: "pagination justify-content-center mb-0" }
const _hoisted_28 = ["onClick"]

import { ref, computed, watch } from 'vue';
import { t } from '@/utils/i18nHelper';


export default /*@__PURE__*/_defineComponent({
  __name: 'DeadlinesWidget',
  props: {
  results: {
    type: Object,
    required: true,
  },
},
  setup(__props) {

const props = __props;

const currentYear = new Date().getFullYear();
const nextYear = currentYear + 1;

const activeYearTab = ref('current'); // 'current' or 'predictions'

const currentPage = ref(1);
const itemsPerPage = ref(5); // Default 5 items per page

const totalPages = computed(() => {
  return Math.ceil(selectedDeadlinesByYear.value.length / itemsPerPage.value);
});

const paginatedDeadlines = computed(() => {
  const start = (currentPage.value - 1) * itemsPerPage.value;
  const end = start + itemsPerPage.value;
  return selectedDeadlinesByYear.value.slice(start, end);
});

watch(activeYearTab, () => {
  currentPage.value = 1; // Reset current page when year tab changes
});

const selectedDeadlinesByYear = computed(() => {
  let deadlines = [];
  if (activeYearTab.value === 'current') {
    deadlines = props.results?.current?.deadlines || [];
  } else {
    deadlines = props.results?.predictions?.deadlines || [];
  }
  // Sort the deadlines by date in ascending order
  return [...deadlines].sort((a, b) => {
    return new Date(a.date).getTime() - new Date(b.date).getTime();
  });
});
const getCategoryColor = (category: string) => {
  switch (category) {
    case 'IRES':
      return 'border-tax';
    case 'INPS':
      return 'border-inps-variable';
    case 'INPS_FISSI':
      return 'border-inps-fixed';
    // Casse Professionali
    case 'SOGGETTIVO':
      return 'border-contrib-soggettivo';
    case 'INTEGRATIVO':
      return 'border-contrib-integrativo';
    case 'MATERNITA':
      return 'border-contrib-maternita';
    default:
      return ''; // No specific border color class
  }
};

const getCategoryHexColor = (category: string) => {
  switch (category) {
    case 'IRES':
      return '#dc3545'; // Rosso - coerente con TaxBreakdownChart
    case 'INPS':
      return '#fd7e14'; // Arancione - coerente con TaxBreakdownChart
    case 'INPS_FISSI':
      return '#ffc107'; // Giallo - coerente con TaxBreakdownChart
    // Casse Professionali (usano gli stessi colori dei contributi INPS)
    case 'SOGGETTIVO':
      return '#fd7e14'; // Arancione (come INPS Variable)
    case 'INTEGRATIVO':
      return '#ffc107'; // Giallo (come INPS Fixed)
    case 'MATERNITA':
      return '#9c27b0'; // Viola (specifico per maternità)
    default:
      return '#cccccc'; // Default color
  }
};

const getCategoryLabel = (category: string) => {
  const keyMap = {
    'IRES': 'fr.deadlines.category_taxes',
    'INPS': 'fr.deadlines.category_inps_variable',
    'INPS_FISSI': 'fr.deadlines.category_inps_fixed',
    // Casse Professionali
    'SOGGETTIVO': 'fr.deadlines.category_contrib_soggettivo',
    'INTEGRATIVO': 'fr.deadlines.category_contrib_integrativo',
    'MATERNITA': 'fr.deadlines.category_contrib_maternita'
  };

  const defaultLabels = {
    'IRES': 'Imposte',
    'INPS': 'INPS Variabili',
    'INPS_FISSI': 'INPS Fissi',
    // Casse Professionali
    'SOGGETTIVO': 'Contrib. Soggettivo',
    'INTEGRATIVO': 'Contrib. Integrativo',
    'MATERNITA': 'Contrib. Maternità'
  };

  const key = keyMap[category as keyof typeof keyMap];
  const defaultLabel = defaultLabels[category as keyof typeof defaultLabels] || category;

  return key ? t(key, defaultLabel) : defaultLabel;
};

const hexToRgba = (hex: string, alpha: number) => {
  const r = parseInt(hex.slice(1, 3), 16);
  const g = parseInt(hex.slice(3, 5), 16);
  const b = parseInt(hex.slice(5, 7), 16);
  return `rgba(${r}, ${g}, ${b}, ${alpha})`;
};

const formatDate = (dateString: string) => {
  const options: Intl.DateTimeFormatOptions = { year: 'numeric', month: 'long', day: 'numeric' };
  return new Date(dateString).toLocaleDateString('it-IT', options);
};

const formatCurrency = (amount: number) => {
  const numVal = parseFloat(amount.toString());
  if (isNaN(numVal)) return '€ 0,00';
  const formatted = numVal.toFixed(2);
  const parts = formatted.split('.');
  const integerPart = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, '.');
  const decimalPart = parts[1];
  return '€ ' + integerPart + ',' + decimalPart;
};

const prevPage = () => {
  if (currentPage.value > 1) {
    currentPage.value--;
  }
};

const nextPage = () => {
  if (currentPage.value < totalPages.value) {
    currentPage.value++;
  }
};

const goToPage = (page: number) => {
  currentPage.value = page;
};

const onItemsPerPageChange = () => {
  currentPage.value = 1; // Reset to first page when changing items per page
};


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("h4", {
          class: "mb-0 fw-semibold",
          innerHTML: _unref(t)('fr.deadlines.widget_title', 'Dettaglio Scadenze')
        }, null, 8, _hoisted_4),
        _createElementVNode("p", _hoisted_5, [
          _createElementVNode("small", {
            innerHTML: _unref(t)('fr.deadlines.widget_description', 'Tutte le scadenze che non dovrai più temere.')
          }, null, 8, _hoisted_6)
        ])
      ]),
      _createElementVNode("ul", _hoisted_7, [
        _createElementVNode("li", _hoisted_8, [
          _createElementVNode("button", {
            class: _normalizeClass(['nav-link', 'p-0', 'bg-transparent', 'border-0', 'fs-12', 'fw-medium', 'text-body', { 'active': activeYearTab.value === 'current' }]),
            onClick: _cache[0] || (_cache[0] = ($event: any) => (activeYearTab.value = 'current')),
            type: "button",
            role: "tab",
            "aria-selected": "true"
          }, [
            _createElementVNode("span", {
              innerHTML: _unref(t)('fr.deadlines.current_year_tab', `Scadenze ${_unref(currentYear)}`, { currentYear: _unref(currentYear) })
            }, null, 8, _hoisted_9)
          ], 2)
        ]),
        _createElementVNode("li", _hoisted_10, [
          _createElementVNode("button", {
            class: _normalizeClass(['nav-link', 'p-0', 'bg-transparent', 'border-0', 'fs-12', 'fw-medium', 'text-body', { 'active': activeYearTab.value === 'predictions' }]),
            onClick: _cache[1] || (_cache[1] = ($event: any) => (activeYearTab.value = 'predictions')),
            type: "button",
            role: "tab",
            "aria-selected": "false"
          }, [
            _createElementVNode("span", {
              innerHTML: _unref(t)('fr.deadlines.next_year_tab', `Scadenze ${nextYear}`, { nextYear: nextYear })
            }, null, 8, _hoisted_11)
          ], 2)
        ])
      ]),
      _createElementVNode("div", _hoisted_12, [
        _createElementVNode("div", _hoisted_13, [
          _createElementVNode("div", _hoisted_14, [
            _createElementVNode("div", _hoisted_15, [
              _createElementVNode("table", _hoisted_16, [
                _createElementVNode("tbody", null, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(paginatedDeadlines.value, (deadline) => {
                    return (_openBlock(), _createElementBlock("tr", {
                      key: deadline.paymentType
                    }, [
                      _createElementVNode("td", null, [
                        _createElementVNode("div", {
                          class: _normalizeClass(['border-start', 'border-2', 'ps-3', 'py-0', getCategoryColor(deadline.category)])
                        }, [
                          _createElementVNode("h6", _hoisted_17, [
                            _createElementVNode("small", null, _toDisplayString(deadline.description), 1),
                            _cache[3] || (_cache[3] = _createTextVNode("   ", -1)),
                            _createElementVNode("small", {
                              class: _normalizeClass(['d-inline-block', 'py-1', 'px-2', 'rounded-2']),
                              style: _normalizeStyle({ 'background-color': hexToRgba(getCategoryHexColor(deadline.category), 0.1), 'color': getCategoryHexColor(deadline.category) })
                            }, [
                              _createElementVNode("span", {
                                innerHTML: getCategoryLabel(deadline.category)
                              }, null, 8, _hoisted_18)
                            ], 4)
                          ]),
                          _createElementVNode("span", _hoisted_19, _toDisplayString(formatDate(deadline.date)), 1)
                        ], 2)
                      ]),
                      _createElementVNode("td", _hoisted_20, [
                        _createElementVNode("span", _hoisted_21, _toDisplayString(formatCurrency(deadline.amount)), 1)
                      ])
                    ]))
                  }), 128)),
                  (selectedDeadlinesByYear.value.length === 0)
                    ? (_openBlock(), _createElementBlock("tr", _hoisted_22, [
                        _createElementVNode("td", {
                          colspan: "2",
                          class: "text-center",
                          innerHTML: _unref(t)('fr.deadlines.no_deadlines_message', 'Nessuna scadenza trovata per questa categoria.')
                        }, null, 8, _hoisted_23)
                      ]))
                    : _createCommentVNode("", true)
                ])
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_24, [
            _createElementVNode("div", _hoisted_25, [
              _cache[5] || (_cache[5] = _createElementVNode("label", { class: "me-2 fw-medium fs-14" }, "Righe per pagina:", -1)),
              _withDirectives(_createElementVNode("select", {
                "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((itemsPerPage).value = $event)),
                onChange: onItemsPerPageChange,
                class: "form-select form-select-sm",
                style: {"width":"auto"}
              }, [...(_cache[4] || (_cache[4] = [
                _createElementVNode("option", { value: 5 }, "5", -1),
                _createElementVNode("option", { value: 10 }, "10", -1),
                _createElementVNode("option", { value: 20 }, "20", -1),
                _createElementVNode("option", { value: 30 }, "30", -1)
              ]))], 544), [
                [_vModelSelect, itemsPerPage.value]
              ])
            ]),
            (totalPages.value > 1)
              ? (_openBlock(), _createElementBlock("nav", _hoisted_26, [
                  _createElementVNode("ul", _hoisted_27, [
                    _createElementVNode("li", {
                      class: _normalizeClass(["page-item", { 'disabled': currentPage.value === 1 }])
                    }, [
                      _createElementVNode("a", {
                        class: "page-link",
                        href: "#",
                        onClick: _withModifiers(prevPage, ["prevent"])
                      }, [...(_cache[6] || (_cache[6] = [
                        _createElementVNode("i", { class: "ri-arrow-left-line" }, null, -1)
                      ]))])
                    ], 2),
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(totalPages.value, (page) => {
                      return (_openBlock(), _createElementBlock("li", {
                        class: _normalizeClass(["page-item", { 'active': page === currentPage.value }]),
                        key: page
                      }, [
                        _createElementVNode("a", {
                          class: "page-link",
                          href: "#",
                          onClick: _withModifiers(($event: any) => (goToPage(page)), ["prevent"])
                        }, _toDisplayString(page), 9, _hoisted_28)
                      ], 2))
                    }), 128)),
                    _createElementVNode("li", {
                      class: _normalizeClass(["page-item", { 'disabled': currentPage.value === totalPages.value }])
                    }, [
                      _createElementVNode("a", {
                        class: "page-link",
                        href: "#",
                        onClick: _withModifiers(nextPage, ["prevent"])
                      }, [...(_cache[7] || (_cache[7] = [
                        _createElementVNode("i", { class: "ri-arrow-right-line" }, null, -1)
                      ]))])
                    ], 2)
                  ])
                ]))
              : _createCommentVNode("", true)
          ])
        ])
      ])
    ])
  ]))
}
}

})